// import { Configuration, OpenAIApi } from 'openai';
import OpenAI from "openai"
import { cv_success, dispatchSpanish, spanish_profile_successful, dispatchJobDetail, SiteError, dispatchEducation, dispatchActivites, dispatchSkills, dispatchPskills, personal_information, cert_function, saveEducation } from './ActionCreator';
import { AdjustGPTResponse } from '../utils/pdfUtil/Adjust_gptRes';
import { baseURL1 } from './baseURL';
import { saveIntoServerCache } from "../utils/saveIntoCache"
import { store } from "./ConfigureStore";
// import {
//   Deepseek_handleLastPageTranslation,
//   Deepseek_convert_employer_JobPost,
//   Deepseek_convertSkills,
//   Deepseek_convertExperience,
//   Deepseek_convertEducation,
//   Deepseek_convertJobInterests,
//   Deepseek_convert,
//   Deepseek_convertOnce
// } from "./DeepseekAI/convert"
import { baseURL } from "./baseURL";

// const openai = new OpenAI({
//   apiKey: process.env.REACT_APP_OPENAI_API_KEY,
//   dangerouslyAllowBrowser: true,
// });

// export const convertOnce = (cred, flag, redirect, language, count = 0) => async (dispatch) => {
//   const valueToBeMapped = { "Fullname": cred.Fullname, "Address": cred.Address, "Email": cred.Email, "Phone_number": cred.Phone_number, "Lang": cred.Lang, "Reference": cred.Reference, "Language": cred.Language, "Website": cred.Website, "Linkedin": cred.Linkedin, "year_of_experience": cred.year_of_experience, EnglishTitle: cred.Job_type };
//     const detailsToFilter = { ...cred};
//     delete detailsToFilter.Fullname;
//     delete detailsToFilter.Address;
//     delete detailsToFilter.Email;
//     delete detailsToFilter.Phone_number;
//     delete detailsToFilter.Language;
//     delete detailsToFilter.year_of_experience;
  
//     const userInformation = `${JSON.stringify(detailsToFilter)}`;

//     const command = `Strictly examine and convert all values of this object ${userInformation} into ${language}. All keys should be in English while values should be changed to ${language}. Do not truncate "Experience" array or any array for brevity but strictly return all the experiences array, make sure to return everything.
//     Organize the output in JSON as follows::
//     {
//       "Professional_summary": "The summary goes here",    
//       "CvType": "Specified job title",
//       "Job_type": "Job_type",
//       "Award": [Award],
//       "Technical_skills": [Technical_skills],
//       "Personal_skills": [Personal_skills],
//       "certification": [certification],
//       "Education": [{
//         "School": "School",
//         "Degree": "Degree",
//         "Course": "Course",
//         "End_date": "End_date",
//       }, ...],
//       "Experience": [{
//         "Where_i_worked": "where_i_worked",
//         "Where_i_worked_location": "where_i_worked_location",
//         "My_job_title":  "Job title",
//         "Work_start_date" : "Work_start_date",
//         "Work_end_date" : "Work_end_date",
//         "Day_to_day_work": [exp_value],
//       }],
//       "Reference": [{
//         "Reference_person_name": "Reference_person_name",
//         "How_do_i_know_this_person": "How_do_i_know_this_person",
//         "Referencee_job_title": "Referencee_job_title",
//         "Reference_email": "Reference_email",
//         "Reference_phone_number": "Reference_phone_number",
//       }]
//     }`
//     await openai.chat.completions.create({
//       model: 'gpt-4o',
//       messages: [{ role: 'user', content: command}],
//       temperature: 0,
//       response_format: { type: "json_object" }
//     }).then(resp => {
//       const result = resp.choices[0].message.content;
//       let r1 = result.replace('\n', "");
//       let r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
//       try {
//         r2 = JSON.parse(r2);
//       } catch (error) {
//         if (error instanceof SyntaxError) {
//           if (count <= 3) {
//             dispatch(convert(cred, flag, redirect, count += 1));
//           } else {
//             dispatch(SiteError("Please try again"));
//           }
//         } else {
//           console.error('Unexpected error:', error.message);
//         }
//       }
//       if (typeof r2 == "object") {
//         const final_result = {...valueToBeMapped, ...r2};
//         console.log("final_result", final_result)
//         if (flag === "resume" && redirect == "/create-profile?download=true") {
//           dispatch(dispatchSpanish(final_result));
//           dispatch(cv_success(final_result));
//           // window.location.assign(baseURL1 + "/generateCV?download=true");
//         } else if (flag === "resume" && redirect == "none") {
//           dispatch(dispatchSpanish(final_result));
//           dispatch(cv_success(final_result));
//         }
//       }
//     }).catch(error => {
//       console.log("convert once error ==>", error)
//       if (error.status === 429  || error.status === 401) {
//         // console.log("429 error, fallback to deepseek.", error);
//         dispatch(Deepseek_convertOnce(cred, flag, redirect, language, count = 0));
//       }
//     })
// }

export const convertOnce =
  (cred, flag, redirect, language, count = 0) =>
  async (dispatch) => {
    try {
      let params = {
        cred,
        language
      };

      let call = await fetch(`${baseURL}/api/aicall/convert-once`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      });

      let response = await call.json();
      console.log("response", response);

      // Check if response is successful
      if (!call.ok) {
        dispatch(SiteError("Please try again"));
      }
      let final_result = response.data;
      if (typeof final_result == "object") {
        console.log("final_result", final_result);
        if (flag === "resume" && redirect == "/create-profile?download=true") {
          dispatch(dispatchSpanish(final_result));
          dispatch(cv_success(final_result));
          // window.location.assign(baseURL1 + "/generateCV?download=true");
        } else if (flag === "resume" && redirect == "none") {
          dispatch(dispatchSpanish(final_result));
          dispatch(cv_success(final_result));
        }
      }
    } catch (error) {
      //dispatch error      
      console.log("Error translating once", error);
    }
  };

// export const convert = (cred, flag, redirect, count = 0) => async (dispatch) => {
//   const valueToBeMapped = { "Fullname": cred.Fullname, "Address": cred.Address, "Email": cred.Email, "Phone_number": cred.Phone_number, "Lang": cred.Lang, "Reference": cred.Reference, "Language": cred.Language, "year_of_experience": cred.year_of_experience,"Education": cred.Education, "Experience": cred.Experience, "Technical_skills": cred.Technical_skills, "Personal_skills": cred.Personal_skills, "Award": cred.Award };
//     const detailsToFilter = { ...cred};
//     delete detailsToFilter.Fullname;
//     delete detailsToFilter.Address;
//     delete detailsToFilter.Email;
//     delete detailsToFilter.Phone_number;
//     delete detailsToFilter.Language;
//     delete detailsToFilter.year_of_experience;
  
//     const userInformation = `${JSON.stringify(detailsToFilter)}`;

//     const command = `Strictly examine and convert all values of this object ${userInformation} into ${cred.Lang[0].lang}. All keys should be in English while values should be changed to ${cred.Lang[0].lang}. Do not truncate "Experience" array or any array for brevity but strictly return all the experiences array, make sure to return everything.
//     Organize the output in JSON as follows::
//     {
//       "Professional_summary": "The summary goes here",    
//       "CvType": "Specified job title",
//       "Job_type": "Job_type",
//     }`

//     await openai.chat.completions.create({
//       model: 'gpt-4o',
//       messages: [{ role: 'user', content: command}],
//       temperature: 0,
//       response_format: { type: "json_object" }
//     }).then(resp => {
//       const result = resp.choices[0].message.content;
//       let r1 = result.replace('\n', "");
//       let r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
//       try {
//         r2 = JSON.parse(r2);
//       } catch (error) {
//         if (error instanceof SyntaxError) {
//           if (count <= 3) {
//             dispatch(convert(cred, flag, redirect, count += 1));
//           } else {
//             dispatch(SiteError("Please try again"));
//           }
//         } else {
//           console.error('Unexpected error:', error.message);
//         }
//       }
//       if (typeof r2 == "object") {
//         const final_result = {...valueToBeMapped, ...r2};
//         if (flag === "resume" && redirect == "/allCv") {
//           dispatch(dispatchSpanish(final_result));
//           dispatch(cv_success(final_result));
//           const store_value = store.getState();
//           let profileId = store_value.userInfo.user.profile_id;
//           window.location.assign(baseURL1 + "/allCv");
//         } else if (flag === "resume" && redirect !== "/allCv") {
//           dispatch(dispatchSpanish(final_result));
//           dispatch(cv_success(final_result));
//           const store_value = store.getState();
//           let profileId = store_value.userInfo.user.profile_id;
//           window.location.assign(baseURL1 + `${redirect}`)
//         } else if (flag === "resume" && redirect == "none") {
//           dispatch(dispatchSpanish(final_result));
//           dispatch(cv_success(final_result));
//         }
//       }
//     }).catch(error => {
//       console.log("convert once error ==>", error)
//       if (error.status === 429  || error.status === 401) {
//         // console.log("429 error, fallback to deepseek.", error);
//         dispatch(Deepseek_convert(cred, flag, redirect, count = 0));
//       }
//     })
// }

export const convert =
  (cred, flag, redirect, count = 0) =>
  async (dispatch) => {
    try {
      let params = {
        cred,
      };

      let call = await fetch(`${baseURL}/api/aicall/convert`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      });

      let response = await call.json();
      console.log("response", response);

      // Check if response is successful
      if (!call.ok) {
        dispatch(SiteError("Please try again"));
      }
      let final_result = response.data;
      if (typeof final_result == "object") {
        if (flag === "resume" && redirect == "/allCv") {
          dispatch(dispatchSpanish(final_result));
          dispatch(cv_success(final_result));
          const store_value = store.getState();
          let profileId = store_value.userInfo.user.profile_id;
          window.location.assign(baseURL1 + "/allCv");
        } else if (flag === "resume" && redirect !== "/allCv") {
          dispatch(dispatchSpanish(final_result));
          dispatch(cv_success(final_result));
          const store_value = store.getState();
          let profileId = store_value.userInfo.user.profile_id;
          window.location.assign(baseURL1 + `${redirect}`)
        } else if (flag === "resume" && redirect == "none") {
          dispatch(dispatchSpanish(final_result));
          dispatch(cv_success(final_result));
        }
      }
    } catch (error) {
      //dispatch error
      console.log("Error translating once", error);
    }
  };

// export const convertJobInterests = (cred, flag, count = 0) => async (dispatch) => {
//   if (cred !== undefined) {
//     const detailsToFilter = { ...cred };
//     detailsToFilter.JobInterests = detailsToFilter?.JobInterests?.filter(e => e !== "");
//     console.log("detailsToFilter", detailsToFilter);
//     const userInformation = `${JSON.stringify(detailsToFilter)}`;

//     const command = `Strictly examine and convert all values of this object ${userInformation} into ${cred.Lang[0].lang}. All keys should be in English while values should be changed to ${cred.Lang[0].lang}. Also, generate five (5) certifications for each of the title in JobInterests. Do not truncate "JobInterests" array or any array for brevity but strictly return all the JobInterests array, make sure to return everything.
//     Organize the output in JSON as follows::
//     {
//       JobInterests: [
//         {
//           "title": jobTitle,
//           "certification": [certification 1, certification 2, certification 3,..., certification 5]
//         }
//       ]
//     }`

//     await openai.chat.completions.create({
//       model: 'gpt-4o',
//       messages: [{ role: 'user', content: command}],
//       temperature: 0,
//       response_format: { type: "json_object" }
//     }).then(resp => {
//       const result = resp.choices[0].message.content;
//       let r1 = result.replace('\n', "");
//       let r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
//       try {
//         r2 = JSON.parse(r2);
//       } catch (error) {
//         if (error instanceof SyntaxError) {
//           if (count <= 3) {
//             dispatch(convert(cred, flag, redirect, count += 1));
//           } else {
//             dispatch(SiteError("Please try again"));
//           }
//         } else {
//           console.error('Unexpected error:', error.message);
//         }
//       }
//       if (typeof r2 == "object") {
//         const final_result = { ...r2 };
//         if (flag === "resume") {
//           const stor = store.getState();
//           const secret = stor.secret.secret;
//           let personalInfo = stor.personal_info.message;
//           let allTitle = final_result?.JobInterests?.map(e => (e?.title));
//           // let allCert = new Array();
//           let allCert = [...new Set([...final_result?.JobInterests?.flatMap(e => (e?.certification))])];
//           console.log("allTitle", allTitle);
//           personalInfo.JobInterests = allTitle;
//           dispatch(personal_information(personalInfo));
//           // you dispatch into cert store here
//           dispatch(cert_function(allCert));
//           saveIntoServerCache("cert", allCert);
//           console.log("personalInfo", personalInfo);
//         }
//       }
//     }).catch(error => {
//       console.log("convert once error ==>", error)
//       if (error.status === 429  || error.status === 401) {
//         // console.log("429 error, fallback to deepseek.", error);
//         dispatch(Deepseek_convert(cred, flag, redirect, count = 0));
//       }
//     })
//   }
// }


export const convertJobInterests =
  (cred, flag, count = 0) =>
  async (dispatch) => {
    try {
      let params = {
        cred,
      };

      let call = await fetch(`${baseURL}/api/aicall/convert-interest`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      });

      let response = await call.json();
      console.log("response", response);

      // Check if response is successful
      if (!call.ok) {
        dispatch(SiteError("Please try again"));
      }
      let final_result = response.data;
      if (typeof final_result == "object") {
        if (flag === "resume") {
          const stor = store.getState();
          const secret = stor.secret.secret;
          let personalInfo = stor.personal_info.message;
          let allTitle = final_result?.JobInterests?.map(e => (e?.title));
          // let allCert = new Array();
          let allCert = [...new Set([...final_result?.JobInterests?.flatMap(e => (e?.certification))])];
          console.log("allTitle", allTitle);
          console.log("personalInfo", personalInfo);
          personalInfo.JobInterests = allTitle;
          dispatch(personal_information(personalInfo));
          // you dispatch into cert store here
          dispatch(cert_function(allCert));
          saveIntoServerCache("cert", allCert);
          console.log("personalInfo", personalInfo);
        }
      }
    } catch (error) {
      //dispatch error
      console.log("Error translating job interest", error);
    }
  };

// export const convertEducation = (cred, flag, count = 0) => async (dispatch) => {
//   if (cred !== undefined) {

//     let schools = cred.Education?.map(e => (e.School));
//     let educ = cred.Education?.map(e => {
//       delete e.School;
//       return e;
//     });
//     const detailsToFilter = { ...cred};
  
//     const userInformation = `${JSON.stringify(detailsToFilter)}`;

//     const command = `Strictly examine and convert all values of this object ${userInformation} into ${cred.Lang[0].lang}. All keys should be in English while values should be changed to ${cred.Lang[0].lang}. Do not truncate "Education" array or any array for brevity but strictly return all the education array, make sure to return everything.
//     Organize the output in JSON as follows::
//     {
//       "Education": [{
//         "Degree": "Degree",
//         "Course": "Course",
//         "End_date": "End_date",
//       }, ...],
//     }`

//     await openai.chat.completions.create({
//       model: 'gpt-4o',
//       messages: [{ role: 'user', content: command}],
//       temperature: 0,
//       response_format: { type: "json_object" }
//     }).then(resp => {
//       const result = resp.choices[0].message.content;
//       let r1 = result.replace('\n', "");
//       let r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
//       try {
//         r2 = JSON.parse(r2);
//       } catch (error) {
//         if (error instanceof SyntaxError) {

//           if (count <= 3) {
//             dispatch(convert(cred, flag, redirect, count += 1));
//           } else {
//             dispatch(SiteError("Please try again"));
//           }
//         } else {
//           console.error('Unexpected error:', error.message);
//         }
//       }
//       if (typeof r2 == "object") {
//         const final_result = { ...r2 };
//         if (flag === "resume") {
//           const stor = store.getState();
//           const secret = stor.secret.secret;
//           for (let i = 0; i <= final_result.Education.length - 1; ++i) {
//             final_result.Education[i].School = schools[i];
//           }
//           dispatch(dispatchEducation(final_result.Education));
//           saveIntoServerCache("eduaction", final_result.Education);
//           // update profile
//           dispatch(saveEducation(final_result.Education, secret));
//         }
//       }
//     }).catch(error => {
//       console.log("convert once error ==>", error)
//       if (error.status === 429  || error.status === 401) {
//         // console.log("429 error, fallback to deepseek.", error);
//         dispatch(Deepseek_convertEducation(cred, flag, count = 0));
//       }
//     })
//   }
// }

export const convertEducation =
  (cred, flag, count = 0) =>
  async (dispatch) => {
        let schools = cred.Education?.map(e => (e.School));
    try {
      let params = {
        cred,
      };

      let call = await fetch(`${baseURL}/api/aicall/convert-education`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      });

      let response = await call.json();
      console.log("response", response);

      // Check if response is successful
      if (!call.ok) {
        dispatch(SiteError("Please try again"));
      }
      let final_result = response.data;
      if (typeof final_result == "object") {
        if (flag === "resume") {
          const stor = store.getState();
          const secret = stor.secret.secret;
          for (let i = 0; i <= final_result.Education.length - 1; ++i) {
            final_result.Education[i].School = schools[i];
          }
          dispatch(dispatchEducation(final_result.Education));
          saveIntoServerCache("education", final_result.Education);
          // update profile
          dispatch(saveEducation(final_result.Education, secret));
        }
      }
    } catch (error) {
      //dispatch error
      console.log("Error translating education", error);
    }
  };


// export const convertExperience = (cred, flag, count = 0) => async (dispatch) => {
//   if (cred !== undefined) {
//     const detailsToFilter = { ...cred};
  
//     const userInformation = `${JSON.stringify(detailsToFilter)}`;

//     const command = `Strictly examine and convert all values of this object ${userInformation} into ${cred.Lang[0].lang}. All keys should be in English while values should be changed to ${cred.Lang[0].lang}. Do not truncate "Experience" array or any array for brevity but strictly return all the experience array, make sure to return everything.
//     Organize the output in JSON as follows::
//     {
//       "Experience": [{
//         "Where_i_worked": "where_i_worked",
//         "Where_i_worked_location": "where_i_worked_location",
//         "My_job_title":  "Job title",
//         "Work_start_date" : "Work_start_date",
//         "Work_end_date" : "Work_end_date",
//         "Day_to_day_work": [exp_value],
//       }],
//     }`

//     await openai.chat.completions.create({
//       model: 'gpt-4o',
//       messages: [{ role: 'user', content: command}],
//       temperature: 0,
//       response_format: { type: "json_object" }
//     }).then(resp => {
//       const result = resp.choices[0].message.content;
//       let r1 = result.replace('\n', "");
//       let r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
//       try {
//         r2 = JSON.parse(r2);
//       } catch (error) {
//         if (error instanceof SyntaxError) {
//           if (count <= 3) {
//             dispatch(convert(cred, flag, redirect, count += 1));
//           } else {
//             dispatch(SiteError("Please try again"));
//           }
//         } else {
//           console.error('Unexpected error:', error.message);
//         }
//       }
//       if (typeof r2 == "object") {
//         const final_result = { ...r2 };
//         if (flag === "resume") {
//           saveIntoServerCache("experience", r2.Experience);
//           dispatch(dispatchActivites(r2.Experience));
//         }
//       }
//     }).catch(error => {
//       console.log("convert once error ==>", error)
//       if (error.status === 429  || error.status === 401) {
//         // console.log("429 error, fallback to deepseek.", error);
//         dispatch(Deepseek_convertExperience(cred, flag, count = 0));
//       }
//     })
//   }
// }

export const convertExperience =
  (cred, flag, count = 0) =>
  async (dispatch) => {
    try {
      let params = {
        cred,
      };

      let call = await fetch(`${baseURL}/api/aicall/convert-experience`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      });

      let response = await call.json();
      console.log("response", response);

      // Check if response is successful
      if (!call.ok) {
        dispatch(SiteError("Please try again"));
      }
      let final_result = response.data;
      if (typeof final_result == "object") {
        if (flag === "resume") {
          saveIntoServerCache("experience", final_result.Experience);
          dispatch(dispatchActivites(final_result.Experience));
        }
      }
    } catch (error) {
      //dispatch error
      console.log("Error translating experience", error);
    }
  };

// export const convertSkills = (cred, flag, count = 0) => async (dispatch) => {
//   if (cred !== undefined) {
//     const detailsToFilter = { ...cred};
  
//     const userInformation = `${JSON.stringify(detailsToFilter)}`;

//     const command = `Strictly examine and convert all values of this object ${userInformation} into ${cred.Lang[0].lang}. All keys should be in English while values should be changed to ${cred.Lang[0].lang}. Do not truncate "Technical skill and Personal skills" array or any array for brevity but strictly return all the Technical skill and Personal skills array, make sure to return everything.
//     Organize the output in JSON as follows::
//     {
//       "Technical_skills": [Technical_skills],
//       "Personal_skills": [Personal_skills],
//     }`

//     await openai.chat.completions.create({
//       model: 'gpt-4o',
//       messages: [{ role: 'user', content: command}],
//       temperature: 0,
//       response_format: { type: "json_object" }
//     }).then(resp => {
//       const result = resp.choices[0].message.content;
//       let r1 = result.replace('\n', "");
//       let r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
//       try {
//         r2 = JSON.parse(r2);
//       } catch (error) {
//         if (error instanceof SyntaxError) {
//           if (count <= 3) {
//             dispatch(convert(cred, flag, redirect, count += 1));
//           } else {
//             dispatch(SiteError("Please try again"));
//           }
//         } else {
//           console.error('Unexpected error:', error.message);
//         }
//       }
//       if (typeof r2 == "object") {
//         const final_result = { ...r2 };

//         if (flag === "resume") {
//           dispatch(dispatchSkills(r2.Technical_skills));
//           dispatch(dispatchPskills(r2.Personal_skills));
//           saveIntoServerCache("technicalSkills", r2.Technical_skills);
//           saveIntoServerCache("personalSkills", r2.Personal_skills);
//         }
//       }
//     }).catch(error => {
//       console.log("convert once error ==>", error)
//       if (error.status === 429  || error.status === 401) {
//         // console.log("429 error, fallback to deepseek.", error);
//         dispatch(Deepseek_convertSkills(cred, flag, count = 0));
//       }
//     })
//   }
// }

export const convertSkills =
  (cred, flag, count = 0) =>
  async (dispatch) => {
    try {
      let params = {
        cred,
      };

      let call = await fetch(`${baseURL}/api/aicall/convert-skills`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      });

      let response = await call.json();
      console.log("response", response);

      // Check if response is successful
      if (!call.ok) {
        dispatch(SiteError("Please try again"));
      }
      let final_result = response.data;
      if (typeof final_result == "object") {
        if (flag === "resume") {
          dispatch(dispatchSkills(final_result.Technical_skills));
          dispatch(dispatchPskills(final_result.Personal_skills));
          saveIntoServerCache("technicalSkills", final_result.Technical_skills);
          saveIntoServerCache("personalSkills", final_result.Personal_skills);
        }
      }
    } catch (error) {
      //dispatch error
      console.log("Error translating skills", error);
    }
  };

// export const convert_employer_JobPost = (cred, flag, redirect, count) => async (dispatch) => {
//   const valueToBeMapped = { "display": cred.display, "paymentPlan": cred.paymentPlan, "compensation": cred.compensation, "duration": cred.duration, "zipCode": cred.zipCode, "Category": cred.Category, "verify": cred.verify, "city": cred.city, "state": cred.state };

//     const detailsToFilter = { ...cred};
//     delete detailsToFilter.display;
//     delete detailsToFilter.paymentPlan;
//     delete detailsToFilter.compensation;
//     delete detailsToFilter.duration;
//     delete detailsToFilter.zipCode;
//     delete detailsToFilter.Category;
//     delete detailsToFilter.verify;
//     delete detailsToFilter.city;
//     delete detailsToFilter.state;
  
//     const userInformation = `${JSON.stringify(detailsToFilter)}`;

//     const command = `Strictly examine and convert all values of this object ${userInformation} into English. All keys should be in English while values should be changed to English. Do not truncate "Description" or any array for brevity but strictly return all the Description, make sure to return everything.
//     Organize the output in JSON as follows:
//     {
//       "jobTitle": "jobTitle",,    
//       "employmentType": "employmentType",
//       "Description": "Description",
//       "Responsibilities": [Responsibilities],
//       "Skills": [Skills],
//     }`

//     await openai.chat.completions.create({
//       model: 'gpt-4o',
//       messages: [{ role: 'user', content: command}],
//       temperature: 0,
//       response_format: { type: "json_object" }
//     }).then(resp => {
//       const result = resp.choices[0].message.content;
//       let r1 = result.replace('\n', "");
//       let r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
//       try {
//         r2 = JSON.parse(r2);
//       } catch (error) {
//         if (error instanceof SyntaxError) {
//           console.error('Invalid JSON format:', error.message);
//           if (count <= 3) {
//             dispatch(convert_employer_JobPost(cred, flag, redirect, count += 1));
//           } else {
//             dispatch(SiteError("Please try again"));
//           }
//         } else {
//           console.error('Unexpected error:', error.message);
//         }
//       }
//       if (typeof r2 == "object") {
//         const final_result = {...valueToBeMapped, ...r2};
//         if (flag === "job posting" && redirect == "/employer/create-job/preview") {
//           dispatch(dispatchJobDetail(final_result));
//           window.location.assign(baseURL1 + "/employer/create-job/preview")
//         }
//       }
//     }).catch(error => {
//       console.log("convert once error ==>", error)
//       if (error.status === 429  || error.status === 401) {
//         // console.log("429 error, fallback to deepseek.", error);
//         dispatch(Deepseek_convert_employer_JobPost(cred, flag, redirect, count = 0));
//       }
//     })
// }


export const convert_employer_JobPost =
  (cred, flag, redirect, count) => async (dispatch) => {
    try {
      let params = {
        cred,
      };

      let call = await fetch(`${baseURL}/api/aicall/convert-job-post`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      });

      let response = await call.json();
      console.log("response", response);

      // Check if response is successful
      if (!call.ok) {
        dispatch(SiteError("Please try again"));
      }
      let final_result = response.data;
      if (typeof final_result == "object") {
        if (
          flag === "job posting" &&
          redirect == "/employer/create-job/preview"
        ) {
          dispatch(dispatchJobDetail(final_result));
          window.location.assign(baseURL1 + "/employer/create-job/preview");
        }
      }
    } catch (error) {
      //dispatch error
      console.log("Error translating job post", error);
    }
  };


// export const handleLastPageTranslation = (cred, flag) => async (dispatch) => {
//   const valueToBeMapped = { "Fullname": cred.Fullname, "Address": cred.Address, "Email": cred.Email, "Phone_number": cred.Phone_number, "Lang": cred.Lang, "Reference": cred.Reference, "Language": cred.Language, "Website": cred.Website, "Linkedin": cred.Linkedin };
//     const detailsToFilter = { ...cred};
//     delete detailsToFilter.Fullname;
//     delete detailsToFilter.Address;
//     delete detailsToFilter.Email;
//     delete detailsToFilter.Phone_number;
//     delete detailsToFilter.Language;
//     delete detailsToFilter.Website;
//     delete detailsToFilter.Linkedin;
  
//     const userInformation = `${JSON.stringify(detailsToFilter)}`;

//     const command = `Strictly examine and convert all values of this object ${userInformation} into ${cred.Lang[0].lang}. All keys should be in English while values should be changed to ${cred.Lang[0].lang}. Do not truncated "Experience" array or any array for brevity but strictly return all the experiences array, make sure to return everything.
//     Return the response or result exactly in object-readable format following this key:
//     "Professional_summary, School, Degree, Course, Course should be a string inside of Education object array and not an array, Start_date, End_date, Interest, CvType, Job_type, Award, Education, Experience, Technical_skills, Personal_skills"
//     Education, Experience, Technical_skills, Personal_skills, Award should all be in an array.`

//     await openai.chat.completions.create({
//       model: 'gpt-4o',
//       messages: [{ role: 'user', content: command}],
//       temperature: 0
//     }).then(resp => {
//       const result = resp.choices[0].message.content;
//       let r1 = result.replace('\n', "");
//       const r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
//       const final_result = {...valueToBeMapped, ...JSON.parse(r2)};
//       if (flag === "resume") {
//         dispatch(dispatchSpanish(final_result));
//         dispatch(cv_success(final_result));
//       } else if (flag === "profile") {
//         const result = AdjustGPTResponse(final_result);
//         dispatch(spanish_profile_successful(result));
//       }
//     }).catch(error => {
//       console.log("convert once error ==>", error)
//       if (error.status === 429  || error.status === 401) {
//         // console.log("429 error, fallback to deepseek.", error);
//         dispatch(Deepseek_handleLastPageTranslation(cred, flag));
//       }
//     })
// }

export const handleLastPageTranslation =
  (cred, flag) => async (dispatch) => {
    try {
      let params = {
        cred,
      };

      let call = await fetch(`${baseURL}/api/aicall/convert-last-page`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      });

      let response = await call.json();
      console.log("response", response);

      // Check if response is successful
      if (!call.ok) {
        dispatch(SiteError("Please try again"));
      }
      let final_result = response.data;
      if (flag === "resume") {
        dispatch(dispatchSpanish(final_result));
        dispatch(cv_success(final_result));
      } else if (flag === "profile") {
        const result = AdjustGPTResponse(final_result);
        dispatch(spanish_profile_successful(result));
      }
    } catch (error) {
      //dispatch error
      console.log("Error translating last page", error);
    }
  };
